import * as am5 from "@amcharts/amcharts5";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import * as am5xy from "@amcharts/amcharts5/xy";
import moment from "moment";
import React, { useEffect } from "react";
import appcolors from "../../constants/Colors";

const monthsss = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const BarChart = ({ data }) => {
  console.log(data, "IETMEMMMMMMMM");

  useEffect(() => {
    // Create root element
    const root = am5.Root.new("barchartdiv");

    // Set themes
    root.setThemes([am5themes_Animated.new(root)]);

    // Create chart
    const chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panX: true,
        panY: true,
        wheelX: "panX",
        wheelY: "zoomX",
        pinchZoomX: true,
        paddingLeft: 0,
        paddingRight: 1,
      })
    );

    // Add cursor
    const cursor = chart.set("cursor", am5xy.XYCursor.new(root, {}));
    cursor.lineY.set("visible", false);

    // Create axes
    const xRenderer = am5xy.AxisRendererX.new(root, {
      minGridDistance: 30,
      minorGridEnabled: true,
    });

    xRenderer.labels.template.setAll({
      rotation: -90,
      centerY: am5.p50,
      centerX: am5.p100,
      paddingRight: 15,
    });

    xRenderer.grid.template.setAll({
      location: 1,
    });

    const xAxis = chart.xAxes.push(
      am5xy.CategoryAxis.new(root, {
        maxDeviation: 0.3,
        categoryField: "month",
        renderer: xRenderer,
        tooltip: am5.Tooltip.new(root, {}),
      })
    );

    const yRenderer = am5xy.AxisRendererY.new(root, {
      strokeOpacity: 0.1,
    });

    yRenderer.labels.template.setAll({
      visible: false, // Hide labels on y-axis
    });

    yRenderer.grid.template.setAll({
      visible: false, // Hide grid lines on y-axis
    });

    const yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        maxDeviation: 0.3,
        renderer: yRenderer,
      })
    );

    // Create series
    const series = chart.series.push(
      am5xy.ColumnSeries.new(root, {
        name: "Series 1",
        xAxis: xAxis,
        yAxis: yAxis,
        valueYField: "earning",
        categoryXField: "month",
        tooltip: am5.Tooltip.new(root, {
          labelText: "{name}\nSAR {valueY} \n{month}\nBranch: {branchName}",
          background: am5.RoundedRectangle.new(root, {
            fill: am5.color("#000000"),
          }),
        }),
      })
    );

    // Adapter to set different colors based on active month
    series.columns.template.adapters.add("fill", (fill, target) => {
      const dataItem = target.dataItem;
      let currentMonth = monthsss[new Date().getMonth()];
      if (dataItem?.dataContext.month === currentMonth) {
        return am5.color(appcolors.primary);
      } else {
        return am5.color(appcolors.primary);
      }
    });

    series.columns.template.setAll({
      cornerRadiusTL: 5,
      cornerRadiusTR: 5,
      strokeOpacity: 0,
    });

    // Prepare data for all months
    const allMonthsData = monthsss.map((month, index) => {
      const matchedData = data.find((item) => {
        const itemMonth = moment()
          .month(item?.month - 1)
          .format("MMM");
        return itemMonth === month;
      });

      return {
        month,
        name: matchedData?.teamMemberName || "No Data",
        earning: matchedData?.totalEarnings || 0,
        branchName: matchedData?.branchName || "No Data",
      };
    });

    // Set data
    xAxis.data.setAll(allMonthsData);
    series.data.setAll(allMonthsData);

    // Make stuff animate on load
    series.appear(1000);
    chart.appear(1000, 100);

    // Cleanup function
    return () => {
      chart.dispose();
      root.dispose();
    };
  }, [data]);

  return (
    <div id="barchartdiv" style={{ width: "100%", height: "400px" }}></div>
  );
};

export default BarChart;
